<template>
  <div class="page">
        <!-- 搜索 -->
  <el-form v-if="isSearch" :model="queryForm" ref="form" label-width="80px" :inline="true" size="small" class="query-form" @submit.native.prevent>
              <el-form-item label="分红名称">
                  <el-input style="width: 177px" v-model="queryForm.incomeName"></el-input>
              </el-form-item>
<!--              <el-form-item label="奖金名称">-->
<!--                  <el-input  v-model="queryForm.bonusName"></el-input>-->
<!--              </el-form-item>-->
<!--              <el-form-item label="分红比例">-->
<!--                  <el-input  v-model="queryForm.incomeRatio"></el-input>-->
<!--              </el-form-item>-->
<!--              <el-form-item label="收入总金额">-->
<!--                  <el-input  v-model="queryForm.totalMoney"></el-input>-->
<!--              </el-form-item>-->
<!--              <el-form-item label="未发放金额">-->
<!--                  <el-input  v-model="queryForm.unsentMoney"></el-input>-->
<!--              </el-form-item>-->
              <el-form-item label="发放货币类型">
<!--                  <el-input  v-model="queryForm.currencyType"></el-input>-->
                  <el-select placeholder="请选择货币类型" clearable v-model="queryForm.currencyType" style="width: 177px">
                      <el-option v-for="item in currencyTypeList" :key="item.key" :label="item.value" :value="item.key"> </el-option>
                  </el-select>
              </el-form-item>
              <el-form-item label="抵扣货币类型">
<!--                  <el-input  v-model="queryForm.deductionCurrencyType"></el-input>-->
                  <el-select placeholder="请选择货币类型" clearable v-model="queryForm.deductionCurrencyType" style="width: 177px">
                      <el-option v-for="item in currencyTypeList" :key="item.key" :label="item.value" :value="item.key"> </el-option>
                  </el-select>
              </el-form-item>
              <el-form-item label="团队领导">
<!--                  <el-input  v-model="queryForm.teamLeaderId"></el-input>-->
                  <GridSelectU style="width: 177px;" title="选择用户" labelName="userName"
                               labelValue="id" :value="queryForm.teamLeaderId" :limit='1' size='small' placeholder='请选择用户'
                               @getValue="getSearchValueUser" :columns="USER_code" :searchs="USER_search" dataListUrl="/mpp/user/findList" entityBeanName="mppUser" queryEntityUrl="/mpp/user/get">
                  </GridSelectU>
              </el-form-item>
<!--              <el-form-item label="发放次数">-->
<!--                  <el-input  v-model="queryForm.sendTimes"></el-input>-->
<!--              </el-form-item>-->
<!--              <el-form-item label="最后一次发放时间">-->
<!--                  <el-input  v-model="queryForm.lastSendTime"></el-input>-->
<!--              </el-form-item>-->
              <el-form-item>
                  <el-button size="small" type="primary" icon="el-icon-search" @click="getModelTeamIncomeList">查询</el-button>
                  <el-button size="small" icon="el-icon-refresh" @click="resetDialog">重置</el-button>
              </el-form-item>
  </el-form>
  <div class="page-content">
    <div class="page-tool-bar">
      <div class="el-btn-group">
        <el-button
          type="primary"
          size="small"
          icon="el-icon-plus"
          @click="addModelTeamIncome"
        >新建</el-button>
        <el-button
          type="warning"
          plain
          size="small"
          icon="el-icon-edit"
          :disabled="multipleSelection.length != 1"
          @click="editModelTeamIncome(null)"
        >修改</el-button>
        <el-button
          type="danger"
          plain
          size="small"
          icon="el-icon-delete"
          :disabled="multipleSelection.length <= 0"
          @click="deleteModelTeamIncome(null)"
        >删除</el-button>
      </div>

      <div class="icon-group">
            <el-upload v-if="this.isImportDate"
              class="upload-demo"
              action="#"
                            :http-request="upload"
              :show-file-list="true">
              <el-button size="small" type="primary">点击上传</el-button>
              <div slot="tip" class="el-upload__tip">只允许导入“xls”或“xlsx”格式文件！</div>
            </el-upload>
        <span
          title="搜索"
          class="icon-box"
          @click="search"
        >
          <Icon color="#606266">
            <Search />
          </Icon>
        </span>
<!--        <span-->
<!--          title="下载模板"-->
<!--          class="icon-box"-->
<!--          @click="importTemplate"-->
<!--        >-->
<!--          <Icon color="#606266">-->
<!--            <ArrowDown />-->
<!--          </Icon>-->
<!--        </span>-->
<!--        <span-->
<!--          class="icon-box"-->
<!--          title="导入数据"-->
<!--          @click="isImport"-->
<!--        >-->
<!--          <Icon color="#606266">-->
<!--            <ArrowExportUp24Regular />-->
<!--          </Icon>-->
<!--        </span>-->
<!--        <span-->
<!--          title="导出数据"-->
<!--          class="icon-box"-->
<!--          @click="exportModelTeamIncomeList"-->
<!--        >-->
<!--          <Icon color="#606266">-->
<!--            <ArrowDownload24Regular />-->
<!--          </Icon>-->
<!--        </span>-->
        <span
          class="icon-box"
          @click="refreshModelTeamIncomeList"
        >
          <Icon color="#606266">
            <Refresh />
          </Icon>
        </span>
      </div>
    </div>
          <!-- 列表数据 -->
    <el-table
      :data="modelTeamIncomeList"
      row-key="id"
      border
      height="100%"
      :header-row-style="{height: '10px'}"
      :header-cell-style="{padding: '10px'}"
      :row-style="{height: '9px'}"
      :cell-style="{padding: '9px'}"
      @selection-change="handleSelectionChange"
      size="small"
    >
      <el-table-column
        align="center"
        type="selection"
        width="60"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="incomeName"
        label="分红名称"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="bonusName"
        label="奖金名称"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="incomeRatio"
        label="分红比例"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="totalMoney"
        label="收入总金额"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="unsentMoney"
        label="未发放金额"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="currencyType"
        label="发放货币类型"
        width="180"
      >
          <template slot-scope="scop">
            {{getCurrencyType(scop.row.currencyType)}}
          </template>
      </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="deductionCurrencyType"
        label="抵扣货币类型"
        width="180"
      >
          <template slot-scope="scop">
            {{getCurrencyType(scop.row.deductionCurrencyType)}}
          </template>
      </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="teamLeaderId"
        label="团队领导"
        width="180"
      >
          <template slot-scope="scope">
              <div v-if="scope.row.user">
                  <div style="text-align: left">账号：{{ scope.row.user.userName }}</div>
                  <div style="text-align: left">手机：{{ scope.row.user.userMobile }}</div>
                  <div style="text-align: left">昵称：{{ scope.row.user.userNickname }}</div>
                  <div style="text-align: left">姓名：{{ scope.row.user.userRealname }}</div>
              </div>
              <div v-else>--</div>
          </template>
      </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="sendTimes"
        label="发放次数"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="lastSendTime"
        label="最后一次发放时间"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="createTime"
        label="创建时间"
        width="180"
      > </el-table-column>
      <el-table-column
        fixed="right"
        align="center"
        label="操作"
        width="400"
      >
        <template slot-scope="scop">
          <div class="operation">
              <div>
                  <el-button
                      @click='addModelRecord(scop.row)'
                      type='primary'
                      size='small'
                  >发放
                  </el-button>
              </div>
              <div @click="checkModelTeamIncomeRecord(scop.row.id)">
                  <span class="operation-label">发放记录</span>
              </div>
              <div @click="checkModelTeamUser(scop.row.teamLeaderId)">
                  <span class="operation-label">团队用户</span>
              </div>
            <div @click="checkModelTeamIncome(scop.row.id)">
              <Icon size="16">
                <Eye24Regular />
              </Icon>
              <span class="operation-label">查看</span>
            </div>
<!--              <div @click="editTeamSendId(scop.row)">-->
<!--                  <Icon size="16">-->
<!--                      <Eye24Regular />-->
<!--                  </Icon>-->
<!--                  <span class="operation-label">修改团队领导</span>-->
<!--              </div>-->
            <div @click="editModelTeamIncome(scop.row.id)">
              <Icon size="16">
                <Edit24Regular />
              </Icon>
              <span class="operation-label">修改</span>
            </div>
            <div @click="deleteModelTeamIncome(scop.row.id)">
              <Icon size="16" style="color: red">
                <Delete24Regular />
              </Icon>
              <span class="operation-label" style="color: red">删除</span>
            </div>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination-box">
      <el-pagination
        @size-change="sizeChange"
        @current-change="currentChange"
        :current-page.sync="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalNum"
        background
        :pager-count="7"
      >
      </el-pagination>
    </div>
    <!-- 新增/查看/修改信息 -->
    <el-dialog
      :title="modelTeamIncomeStates[modelTeamIncomeState]"
      :visible.sync="showDialog"
      width="60%"
      @close="closeDialog"
    >
      <div>
        <el-form
          :model="modelTeamIncome"
          ref="modelTeamIncomeForm"
          :rules="rules"
          label-width="120px"
          :inline="true"
          size="small"
        >
          <el-form-item
            label="分红名称"
            prop="incomeName"
          >
            <el-input
              size="small"
              style='width: 177px'
              v-model="modelTeamIncome.incomeName"
              :disabled="modelTeamIncomeState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="奖金名称"
            prop="bonusName"
          >
            <el-input
              size="small"
              style='width: 177px'
              v-model="modelTeamIncome.bonusName"
              :disabled="modelTeamIncomeState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="分红比例"
            prop="incomeRatio"
          >
            <el-input
              size="small"
              style='width: 177px'
              v-model="modelTeamIncome.incomeRatio"
              :disabled="modelTeamIncomeState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="收入总金额"
            prop="totalMoney"
          >
            <el-input
              size="small"
              style='width: 177px'
              v-model="modelTeamIncome.totalMoney"
              :disabled="modelTeamIncomeState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="未发放金额"
            prop="unsentMoney"
          >
            <el-input
              size="small"
              style='width: 177px'
              v-model="modelTeamIncome.unsentMoney"
              :disabled="modelTeamIncomeState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="发放货币类型"
            prop="currencyType"
          >
<!--            <el-input-->
<!--              size="small"-->
<!--              v-model="modelTeamIncome.currencyType"-->
<!--              :disabled="modelTeamIncomeState == 'check'"-->
<!--            ></el-input>-->
              <el-select placeholder="请选择货币类型" clearable :disabled="modelTeamIncomeState == 'check'" v-model="modelTeamIncome.currencyType" style="width: 177px">
                  <el-option v-for="item in currencyTypeList" :key="item.key" :label="item.value" :value="item.key"> </el-option>
              </el-select>
          </el-form-item>
          <el-form-item
            label="抵扣货币类型"
            prop="deductionCurrencyType"
          >
<!--            <el-input-->
<!--              size="small"-->
<!--              v-model="modelTeamIncome.deductionCurrencyType"-->
<!--              :disabled="modelTeamIncomeState == 'check'"-->
<!--            ></el-input>-->
              <el-select placeholder="请选择货币类型" clearable :disabled="modelTeamIncomeState == 'check'" v-model="modelTeamIncome.deductionCurrencyType" style="width: 177px">
                  <el-option v-for="item in currencyTypeList" :key="item.key" :label="item.value" :value="item.key"> </el-option>
              </el-select>
          </el-form-item>
          <el-form-item
            label="团队领导"
            prop="teamLeaderId"
          >
<!--            <el-input-->
<!--              size="small"-->
<!--              style='width: 177px'-->
<!--              v-model="modelTeamIncome.teamLeaderId"-->
<!--              :disabled="modelTeamIncomeState == 'check'"-->
<!--            ></el-input>-->
              <GridSelectU style="width: 177px;" title="选择用户" labelName="userName" :disabled="modelTeamIncomeState != 'add'"
                           labelValue="id" :value="modelTeamIncome.teamLeaderId" :limit='1' size='small' placeholder='请选择用户'
                           @getValue="getValueUser" :columns="USER_code" :searchs="USER_search" dataListUrl="/mpp/user/findList" entityBeanName="mppUser" queryEntityUrl="/mpp/user/get">
              </GridSelectU>
          </el-form-item>
          <el-form-item
            label="发放次数"
            prop="sendTimes"
          >
            <el-input
              size="small"
              style='width: 177px'
              v-model="modelTeamIncome.sendTimes"
              :disabled="modelTeamIncomeState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="最后一次发放时间"
            prop="lastSendTime"
          >
<!--            <el-input-->
<!--              size="small"-->
<!--              v-model="modelTeamIncome.lastSendTime"-->
<!--              :disabled="modelTeamIncomeState == 'check'"-->
<!--            ></el-input>-->
              <el-date-picker
                  style='width: 177px'
                  v-model='modelTeamIncome.lastSendTime'
                  :disabled="modelTeamIncomeState == 'check'"
                  type='datetime'
                  format='yyyy-MM-dd HH:mm:ss'
                  value-format='yyyy-MM-dd HH:mm:ss'
                  placeholder='选择日期时间'>
              </el-date-picker>
          </el-form-item>
        </el-form>
      </div>

      <div
        slot="footer"
        class="flex justify-end"
      >
        <el-button @click="closeDialog">关闭</el-button>
        <el-button
          type="primary"
          @click="submitForm"
          v-if="modelTeamIncomeState != 'check'"
        >确定</el-button>
      </div>
    </el-dialog>


      <!-- 修改领导信息 -->
      <el-dialog
          title="修改领导信息"
          :visible.sync="isShowUser"
          width="400px"
          @close="closeTeamSendId"
      >
          <div>
              <el-form
                  :model="editUser"
                  ref="modelTeamEditSendForm"
                  :rules="rules"
                  label-width="120px"
                  :inline="true"
                  size="small"
              >
                  <el-form-item
                      label="团队领导"
                      prop="teamLeaderId"
                  >
                      <GridSelectU style="width: 177px;" title="选择用户" labelName="userName"
                                   labelValue="id" :value="editUser.teamLeaderId" :limit='1' size='small' placeholder='请选择用户'
                                   @getValue="getValueUser2" :columns="USER_code" :searchs="USER_search" dataListUrl="/mpp/user/findList" entityBeanName="mppUser" queryEntityUrl="/mpp/user/get">
                      </GridSelectU>
                  </el-form-item>
              </el-form>
          </div>

          <div
              slot="footer"
              class="flex justify-end"
          >
              <el-button @click="closeTeamSendId">关闭</el-button>
              <el-button
                  type="primary"
                  @click="submitForm2"
              >确定</el-button>
          </div>
      </el-dialog>
  </div>
      <el-drawer title="发放管理" :visible.sync="isShowRecord" direction="rtl" size="70%"
                 :before-close="closeModelTeamIncomeRecord">
          <ModelTeamIncomeSendRecord ref="modelTeamIncomeSendRecord" />
      </el-drawer>
      <el-drawer title="团队用户" :visible.sync="isShowUserRecord" direction="rtl" size="70%"
                 :before-close="closeModelTeamUser">
          <ModelIncomeUserRecord ref="modelIncomeUserRecord" />
      </el-drawer>
  </div>
</template>

<script>
import { ArrowDownload24Regular, ArrowExportUp24Regular } from '@v2icons/fluent';
import { GridDots, Refresh, Printer, ArrowUp, ArrowDown, Search } from '@v2icons/tabler';
import { Edit24Regular, Delete24Regular, Eye24Regular } from '@v2icons/fluent';
import { exprotExcel, importTemplate, importDate, get, post, put, deleteFun } from '@/utils/request.js';
import GridSelectU from '@/components/gridselect/index.vue';
import { USER, USER_SEARCH } from '@/utils/constant';
import ModelTeamIncomeSendRecord from '@/components/model/ModelTeamIncomeSendRecord.vue';
import ModelIncomeUserRecord from '@/components/model/ModelUserRecord.vue';

export default {
    components: {
        GridSelectU,
        ModelTeamIncomeSendRecord,
        ModelIncomeUserRecord,
        Edit24Regular,
        Delete24Regular,
        Eye24Regular,
        GridDots,
        Refresh,
        Printer,
        ArrowUp,
        ArrowDown,
        ArrowDownload24Regular,
        ArrowExportUp24Regular,
        Search
    },
        watch: {
            checkState(val) {
                if (val == 'check') {
                    this.resetModelTeamIncomeList();
                    this.getModelTeamIncomeList(this.queryForm);
                    this.$emit('resetCheckState');
                } else if (val == 'reset') {
                    this.resetModelTeamIncomeList();
                    this.getModelTeamIncomeList();
                    this.$emit('resetCheckState');
                }
            }
        },
    data() {
            return {
                queryForm:{
                     incomeName: '', //分红名称
                     bonusName: '', //奖金名称
                     incomeRatio: '', //分红比例
                     totalMoney: '', //收入总金额
                     unsentMoney: '', //未发放金额
                     currencyType: '', //发放货币类型
                     deductionCurrencyType: '', //抵扣货币类型
                     teamLeaderId: '', //团队领导
                     sendTimes: '', //发放次数
                     lastSendTime: '', //最后一次发放时间
                },
                USER_code: USER,
                USER_search: USER_SEARCH,
                loading: false,
                showDialog: false,
                isImportDate: false,
                isSearch: false,
                pageSize: 10,
                currentPage: 1,
                totalNum: 0,
                currentUserId: '',
                modelTeamIncomeState: 'add',
                modelTeamIncomeStates: {
                    add: '新建团队分红',
                    check: '查看团队分红',
                    edit: '修改团队分红'
                },

                multipleSelection: [],
                modelTeamIncomeList: [],
                modelTeamIncome: {
                    id: '', //
                    incomeName: '', //分红名称
                    bonusName: '', //奖金名称
                    incomeRatio: '', //分红比例
                    totalMoney: '', //收入总金额
                    unsentMoney: '', //未发放金额
                    currencyType: '', //发放货币类型
                    deductionCurrencyType: '', //抵扣货币类型
                    teamLeaderId: '', //团队领导
                    sendTimes: '', //发放次数
                    lastSendTime: '', //最后一次发放时间
                },
                btnLoading: false,

                rules: {
                    incomeName: [{ required: true, message: '分红名称不能为空', trigger: 'blur' }],
                    bonusName: [{ required: true, message: '奖金名称不能为空', trigger: 'blur' }],
                    incomeRatio: [{ required: true, message: '分红比例不能为空', trigger: 'blur' }],
                    totalMoney: [{ required: true, message: '收入总金额不能为空', trigger: 'blur' }],
                    unsentMoney: [{ required: true, message: '未发放金额不能为空', trigger: 'blur' }],
                    currencyType: [{ required: true, message: '发放货币类型不能为空', trigger: 'blur' }],
                    deductionCurrencyType: [{ required: true, message: '抵扣货币类型不能为空', trigger: 'blur' }],
                    teamLeaderId: [{ required: true, message: '团队领导不能为空', trigger: 'blur' }],
                    sendTimes: [{ required: true, message: '发放次数不能为空', trigger: 'blur' }],
                    lastSendTime: [{ required: true, message: '最后一次发放时间不能为空', trigger: 'blur' }],
                },

                currencyTypeList: [],

                isShowRecord: false,
                isShowUserRecord: false,
                editUser: {teamLeaderId: '', id: ''},
                isShowUser: false,
            };
        },
        created() {
            this.getModelTeamIncomeList();
            this.getCurrencyTypeList();
        },
        methods: {
            search(){
                this.isSearch = !this.isSearch;
            },
            getValueUser(value) {
                this.modelTeamIncome.teamLeaderId = value
            },
            getValueUser2(value) {
                this.editUser.teamLeaderId = value
            },
            getSearchValueUser(value){
                this.queryForm.teamLeaderId = value
            },
            checkModelTeamIncomeRecord(id){
                this.isShowRecord = true;
                this.$nextTick(()=>{
                    this.$refs.modelTeamIncomeSendRecord.init(id)
                })
            },
            closeModelTeamIncomeRecord(){
                this.isShowRecord = false;
            },
            editTeamSendId(item){
                this.editUser.id = item.id
                this.editUser.teamLeaderId = item.teamLeaderId
                this.isShowUser = true;
            },
            closeTeamSendId(){
                this.editUser = {teamLeaderId: '', id: ''}
                this.isShowUser = false;
            },
            checkModelTeamUser(id){
                this.isShowUserRecord = true
                this.$nextTick(()=>{
                    this.$refs.modelIncomeUserRecord.init(id)
                })
            },
            closeModelTeamUser(){
                this.isShowUserRecord = false
            },
            //获取货币类型
            getCurrencyTypeList() {
                get(`/mpp/utils/getEnum`, { enumType: `currency_type` }).then((res) => {
                    if (res.success) {
                        this.currencyTypeList = res.enumList;
                    }
                });
            },
            getCurrencyType(type) {
                for (const index in this.currencyTypeList) {
                    if (this.currencyTypeList[index].key == type) {
                        return this.currencyTypeList[index].value;
                    }
                }
            },
            resetModelTeamIncomeList() {
                this.pageSize = 10;
                this.currentPage = 1;
                this.modelTeamIncomeList = [];
            },
            resetDialog() {
                this.modelTeamIncomeState = 'add';
                this.showDialog = false;
                this.queryForm = {
                      incomeName: '', //分红名称
                      bonusName: '', //奖金名称
                      incomeRatio: '', //分红比例
                      totalMoney: '', //收入总金额
                      unsentMoney: '', //未发放金额
                      currencyType: '', //发放货币类型
                      deductionCurrencyType: '', //抵扣货币类型
                      teamLeaderId: '', //团队领导
                      sendTimes: '', //发放次数
                      lastSendTime: '', //最后一次发放时间
                };
                this.getModelTeamIncomeList();
            },
            closeDialog() {
                this.showDialog = false
                this.modelTeamIncome = {
                      id: '', //
                      incomeName: '', //分红名称
                      bonusName: '', //奖金名称
                      incomeRatio: '', //分红比例
                      totalMoney: '', //收入总金额
                      unsentMoney: '', //未发放金额
                      currencyType: '', //发放货币类型
                      deductionCurrencyType: '', //抵扣货币类型
                      teamLeaderId: '', //团队领导
                      sendTimes: '', //发放次数
                      lastSendTime: '', //最后一次发放时间
                };
            },
            // 发放
            addModelRecord(item) {
                this.$confirm('即将发放分红, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    get('/model/teamincome/send', { id: item.id }).then((res) => {
                        if (res.success) {
                            this.$message({
                                message: res.data,
                                type: 'success',
                                duration: 2000
                            });
                            this.refreshModelTeamIncomeList();
                        } else {
                            this.$message({
                                message: res.msg,
                                type: 'error',
                                duration: 2000
                            });
                        }
                    });
                }).catch(() => {
                });
            },
            submitForm() {
                if (this.modelTeamIncomeState == 'add') {
                    this.$refs.modelTeamIncomeForm.validate((valid) => {
                        if (valid) {
                            console.log('submit');
                            post(`/model/teamincome/add`,{ ...this.modelTeamIncome }).then((res) => {
                                if (res.success) {
                                    this.$message({
                                        message: res.msg,
                                        type: 'success',
                                        duration: 2000,
                                    });
                                    this.resetModelTeamIncomeList();
                                    this.resetDialog();
                                } else {
                                    this.$message({
                                        message: res.msg,
                                        type: 'error',
                                        duration: 2000
                                    });
                                }
                            });
                        }
                    });
                } else if (this.modelTeamIncomeState == 'edit') {
                    this.$refs.modelTeamIncomeForm.validate((valid) => {
                        if (valid) {
                            console.log('submit');
                            delete this.modelTeamIncome.user;
                            post(`/model/teamincome/edit`,{ ...this.modelTeamIncome }).then((res) => {
                                if (res.success) {
                                    this.$message({
                                        message: res.msg,
                                        type: 'success',
                                        duration: 2000
                                    });
                                    this.resetModelTeamIncomeList();
                                    this.resetDialog();
                                } else {
                                    this.$message({
                                        message: res.msg,
                                        type: 'error',
                                        duration: 2000
                                    });
                                }
                            });
                        }
                    });
                }
            },
            submitForm2() {
                this.$refs.modelTeamEditSendForm.validate((valid) => {
                    if (valid) {
                        console.log('submit');
                        post(`/model/teamincome/edit`,{ ...this.editUser }).then((res) => {
                            if (res.success) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                    duration: 2000
                                });
                                this.resetModelTeamIncomeList();
                                this.closeTeamSendId();
                                this.getModelTeamIncomeList();
                            } else {
                                this.$message({
                                    message: res.msg,
                                    type: 'error',
                                    duration: 2000
                                });
                            }
                        });
                    }
                });
            },
            addModelTeamIncome() {
                this.showDialog = true;
                this.modelTeamIncomeState = 'add';
            },
            checkModelTeamIncome(modelTeamIncomeId) {
                console.log(modelTeamIncomeId);
                this.currentModelTeamIncomeId = modelTeamIncomeId;

                this.getModelTeamIncomeById();
                this.showDialog = true;
                this.modelTeamIncomeState = 'check';
            },
            editModelTeamIncome(modelTeamIncomeId) {
                console.log('modelTeamIncome', modelTeamIncomeId);
                if (modelTeamIncomeId) {
                    this.currentModelTeamIncomeId = modelTeamIncomeId;
                    this.getModelTeamIncomeById();
                } else {
                    this.modelTeamIncome = { ...this.modelTeamIncome, ...this.multipleSelection[0] };
                }

                this.showDialog = true;
                this.modelTeamIncomeState = 'edit';
            },
            deleteModelTeamIncome(modelTeamIncomeId) {
                let ids = '';
                if (modelTeamIncomeId) {
                    ids = modelTeamIncomeId;
                } else {
                    ids = this.multipleSelection.map((modelTeamIncome) => modelTeamIncome.id).join(',');
                }
                console.log({ ids });
                this.$confirm('确定删除所选项吗？', '提示', {
                    type: 'warning'
                })
                    .then(() => {
                        deleteFun(`/model/teamincome/delete`,{ ids }).then((res) => {
                            if (res.success) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                    duration: 2000
                                });
                                this.resetModelTeamIncomeList();
                                this.getModelTeamIncomeList();
                            } else {
                                this.$message({
                                    message: res.msg,
                                    type: 'error',
                                    duration: 2000
                                });
                            }
                        });
                    })
                    .catch(() => {});
            },
            refreshModelTeamIncomeList() {
                this.resetModelTeamIncomeList();
                this.getModelTeamIncomeList();
            },
            getModelTeamIncomeList(query = {}) {
                this.loading = true;
                get(`/model/teamincome/findList`,{  ...this.queryForm, pageNum: this.currentPage, pageSize: this.pageSize }).then((res) => {
                    this.loading = false;
                    if (res.success) {
                        this.modelTeamIncomeList = res.page.list;
                        this.totalNum = res.page.total;
                    } else {
                        this.$message({
                            message: res.msg,
                            type: 'error',
                            duration: 2000
                        });
                    }
                });
            },
            getModelTeamIncomeById() {
                get(`/model/teamincome/get`,{ id: this.currentModelTeamIncomeId }).then((res) =>{
                    if(res.success){
                      this.modelTeamIncome = { ...this.modelTeamIncome, ...res.modelTeamIncome };
                    } else {
                        this.$message({
                            message: res.msg,
                            type: 'error',
                            duration: 2000
                        });
                    }
                });
            },
            /**
             * 导出信息
             */
            exportModelTeamIncomeList() {
                //this.btnLoading = true;
                exprotExcel(`/model/teamincome/export`, {...this.queryForm});
            },
            /**
             * 导出模板
             */
            importTemplate() {
                this.btnLoading = true;
                importTemplate(`/model/teamincome/importTemplate`, this.btnLoading);
            },
            /**
             * 导入数据
             */
            isImport() {
                this.isImportDate = !this.isImportDate;
            },
            upload(params){
              const file = params.file;
              const formData = new FormData();
              formData.append('file', file);
              console.log({ formData });
              importDate(`/model/teamincome/importData`,formData);
              this.refreshModelTeamIncomeList();
            },
            handleSelectionChange(value) {
                console.log(value);
                this.multipleSelection = value;
            },
            currentChange(page) {
                this.currentPage = page;
                this.getModelTeamIncomeList();
            },
            sizeChange(size) {
                this.pageSize = size;
                this.getModelTeamIncomeList();
            }
        }

};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__header {
    border-bottom: 1px solid #eee;
}
.operation {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #409eff;
    font-size: 12px;

    & > div {
        display: flex;
        align-items: center;
        padding: 0 5px;
        cursor: pointer;
    }

    .operation-label {
        margin-left: 3px;
    }
}
</style>